import "./App.css";
import Navbar from "./components/Navbar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Home from "./components/pages/Home";
import React, { useEffect, useState } from "react";
import Hurricane from "./components/pages/Hurricane";
import HurricaneDebby from "./components/pages/HurricaneDebby";
import People from "./components/pages/People";
import AUDT from "./components/pages/AUDT";
import Projects from "./components/pages/Projects";
import OngoingProjectsList from "./components/pages/OngoingProjectsList";
import RecentlyCompletedProjectsList from "./components/pages/RecentlyCompletedProjectsList";
import PersonDetail from "./components/pages/PersonDetail";
import { navLinks } from "./components/navData";
import ContentPage from "./components/ContentPage";
import useProjects from "./hooks/useProjects";
import useScrollReveal from "./hooks/useScrollReveal";
import PeopleDetails from "./components/PeopleDetails";
import {
  teamMates,
} from "./components/teamData"; // Import your data
import Publications from "./components/pages/Publications";
import News from "./components/pages/News";
import NewsDetail from "./components/pages/NewsDetail";
import NewsArchive from "./components/pages/NewsArchive";
import Join from "./components/pages/Join";
import GeoHealth from "./components/pages/GeoHealth";
import ParisOlympic from "./components/pages/ParisOlymipicRDP";
import ParisOlympic26Jul from "./components/pages/ParisOlympic26Jul";
import ParisOlympic29Jul from "./components/pages/ParisOlymipic29Jul";
import ParisOlympic30Jul from "./components/pages/ParisOlympic30Jul";
import ParisOlympic31Jul from "./components/pages/ParisOlympics31Jul";
import ParisOlympics01Aug from "./components/pages/ParisOlympics1Aug";
import ParisOlympics02Aug from "./components/pages/ParisOlympics02Aug";
import ParisOlympics03Aug from "./components/pages/ParisOlympics03Aug";
import ParisOlympics04Aug from "./components/pages/ParisOlympics04Aug";
import ParisOlympics05Aug from "./components/pages/ParisOlympics5Aug";
import ParisOlympics06Aug from "./components/pages/ParisOlympics06Aug";
import ParisOlympics07Aug from "./components/pages/ParisOlympics07Aug";
import ParisOlympics08Aug from "./components/pages/ParisOlympics08Aug";
import ParisOlympics09Aug from "./components/pages/ParisOlympics09Aug";
import ParisOlympics10Aug from "./components/pages/ParisOlympics10Aug";
import ParisOlympic11Aug from "./components/pages/ParisOlympics11Aug";
import ParisOlympics28Aug from "./components/pages/ParisOlympics28Aug";
import $ from 'jquery';
import Internship from "./components/pages/internship";
import CityDigitalTwinBook from "./components/pages/cityDigitalTwinBook"; 







const ExternalRedirect = ({ url }) => {
  useEffect(() => {
    window.location.href = url;
  }, [url]);

  return null;
};

export const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
};

/* Drives the [data-reveal] entrance transitions; re-scans on every route
   change so newly mounted pages are picked up. */
const ScrollReveal = () => {
  const location = useLocation();
  useScrollReveal([location.pathname]);
  return null;
};

function App() {
  const [peopleProjects, setPeopleProjects] = useState({});
  
  // Use the custom hook to fetch all projects
  const { projects, loading, error } = useProjects();

  useEffect(() => {
    if (projects && projects.length > 0) {
      // Create a data structure that associates people with projects
      const peopleProjectsData = {};
      projects.forEach((project) => {
        if (project.Collaborators) {
          const collaborators = project.Collaborators.split(",").map((name) =>
            name.trim()
          );
          collaborators.forEach((collaborator) => {
            // Replace spaces in names with underscores and convert to lowercase
            const formattedName = collaborator
              .replace(/\s+/g, "_")
              .toLowerCase();
            if (!peopleProjectsData[formattedName]) {
              peopleProjectsData[formattedName] = [];
            }
            peopleProjectsData[formattedName].push(project);
          });
        }
      });
      setPeopleProjects(peopleProjectsData);
    }
  }, [projects]);

  return (
    <>
      <Router>
        <Navbar navLinks={navLinks} />
        <ScrollToTop />
        <ScrollReveal />
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/lab-website-v2" exact element={<Home />} />
          <Route path="/geohealth" element={<GeoHealth />} />
          <Route path="/colab" element={<ExternalRedirect url="https://utcitycolab.org" />} />
          
          <Route path="/audt" element={<AUDT />} />
          <Route path="/hurricane" element={<Hurricane />} />
          <Route path="/hurricanedebby" element={<HurricaneDebby />} />
          <Route path="/ParisOlympics" element={<ParisOlympic />} />
          <Route path="/ParisOlympic" element={<ParisOlympic />} />
          <Route path="/ParisOlympics26Jul" element={<ParisOlympic26Jul />} />
          <Route path="/ParisOlympics29Jul" element={<ParisOlympic29Jul />} />
          <Route path="/ParisOlympics30Jul" element={<ParisOlympic30Jul />} />
          <Route path="/ParisOlympics31Jul" element={<ParisOlympic31Jul />} />
          <Route path="/ParisOlympics01Aug" element={<ParisOlympics01Aug />} />
          <Route path="/ParisOlympics02Aug" element={<ParisOlympics02Aug />} />
          <Route path="/ParisOlympics03Aug" element={<ParisOlympics03Aug />} />
          <Route path="/ParisOlympics04Aug" element={<ParisOlympics04Aug />} />
          <Route path="/ParisOlympics05Aug" element={<ParisOlympics05Aug />} />
          <Route path="/ParisOlympics06Aug" element={<ParisOlympics06Aug />} />
          <Route path="/ParisOlympics07Aug" element={<ParisOlympics07Aug />} />
          <Route path="/ParisOlympics08Aug" element={<ParisOlympics08Aug />} />
          <Route path="/ParisOlympics09Aug" element={<ParisOlympics09Aug />} />
          <Route path="/ParisOlympics10Aug" element={<ParisOlympics10Aug />} />
          <Route path="/ParisOlympics11Aug" element={<ParisOlympic11Aug />} />
          <Route path="/ParisOlympics28Aug" element={<ParisOlympics28Aug />} />







          <Route
            path="/projects"
            element={<Projects />}
          />
          <Route path="/projects/:category" element={<Projects />} />
                <Route path="/ongoing-projects-list" element={<OngoingProjectsList />} />
                <Route path="/recently-completed-projects" element={<RecentlyCompletedProjectsList />} />
                <Route path="/team/:name" element={<PersonDetail />} />
          <Route path="/publications" element={<Publications />} />
          <Route path="/News" element={<News />} />
          <Route path="/news/all" element={<NewsArchive />} />
          <Route path="/news/:id" element={<NewsDetail />} />

          <Route path="/content/:targetSection" element={<ContentPage />} />

          <Route path="/Team" element={<People />} />
          {[
            ...teamMates
          ].map((person, index) => (
            <Route
              key={index}
              path={`/Team/${person.name.replace(/\s+/g, "_").toLowerCase()}`}
              element={
                <PeopleDetails
                  person={person}
                  peopleProjects={peopleProjects}
                />
              }
            />
          ))}
          <Route path="/join" element={<Join />} />
          <Route path="/internship" element={<Internship />} />
          <Route path="/dt-book" element={<CityDigitalTwinBook />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
